import { useContext } from 'react';
import { Button, Stack } from '@karma/components';
import { useTranslation } from 'react-i18next';
import { getRedirectLinkToTag } from '@karma/utils/functions/redirectLink';
import { useSelector } from 'react-redux';
import RightArrowIcon from '@karma/components/icons/RightArrowIcon';
import CardTagRegular from 'components/molecules/CardTagRegular/CardTagRegular';
import { getUserId } from 'store/user/selectors';
import { ReferralSourceContext } from 'contexts/ReferralSourceContext';
import Alooma from 'services/alooma';
import * as ALOOMA from 'consts/alooma';
import hasDiscount from 'functions/hasDiscount';
import { CardContainer, CardLink } from './CardTagSeo.style';

const CardTagSeo = ({ tag }) => {
  const { t } = useTranslation();

  const { id: tagId, rule_name: ruleName, stake, original_url: originalUrl, price } = tag;

  const userId = useSelector(getUserId);
  const source = useContext(ReferralSourceContext);

  const hasOriginalPrice = hasDiscount(price?.current_price, price?.original_price, price?.currency?.symbol);

  const redirectLinkToTag = getRedirectLinkToTag({ cashback: !!stake, ruleName, source, tagId, userId, originalUrl });

  const contextDataAttrs = Alooma.useContextDataAttrs();

  return (
    <CardContainer>
      <CardLink href={tag.tag_url} target="_blank">
        <CardTagRegular tag={tag} clickable={false} />
      </CardLink>
      <Stack fullWidth justifyContent="flex-end">
        <Button
          size="verySmall"
          type="underlinedText"
          as="a"
          target="_blank"
          rel="nofollow"
          href={redirectLinkToTag}
          {...contextDataAttrs}
          data-alooma-element={ALOOMA.ELEMENTS.SHOP_NOW}
          Icon={RightArrowIcon}
          iconPosition="right"
          style={{ marginTop: !hasOriginalPrice && '20px' }}
        >
          {t('app:shopNow')}
        </Button>
      </Stack>
    </CardContainer>
  );
};

export default CardTagSeo;
